import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { GtagInitializer } from "./components/GtagInitializer";
import { MiddlewareWrapper } from "./components/MiddlewareWrapper";

import Call from "./pages/Call";
import Review from "./pages/Review";
import Register from "./pages/Register";
import Confirm from "./pages/Confirm";
// import Example from "./pages/Example";
// import NotFound from "./pages/NotFound";
import Success from "./pages/Success";
import InterpreterSelectLanguage from "./pages/InterpreterSelectLanguage";
import AgreementPage from "./pages/Agreement";
import Callback from "./pages/Callback";
import Appointment from "./pages/Appointment";
import ConnectFailed from "./pages/ConnectFailed";
import Privacy from "./pages/Privacy";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPin from "./pages/ForgotPin";

export default function AppRouter({ config }) {
  const env = process.env.REACT_APP_BUILD_ENV;
  const basename = env === "dev" || env === "uat" ? "/v2" : "/webview/v2";

  const path = window.location.pathname;

  const search = window.location.search || "";
  const hash = window.location.hash || "";

  // const shouldRewriteMTL = path === "/MTL" || path.startsWith("/MTL/");

  // if (shouldRewriteMTL) {
  //   const rewrittenPath = path.replace(/^\/MTL(\/|$)/, "/");
  //   window.location.replace(`${rewrittenPath}${search}${hash}`);
  //   return null;
  // }

  const shouldRedirect =
    path === "/" ||
    path === "" ||
    path === "/index.html" ||
    path.includes("/MTL/") ||
    path.includes("/thailife/") ||
    ((env === "dev" || env === "uat") && path.startsWith("/webview/v2")) ||
    (env !== "dev" && env !== "uat" && path.startsWith("/v2"));

  if (shouldRedirect) {
    const targetBase = env === "dev" || env === "uat" ? "/v2" : "/webview/v2";

    // Clean up the path
    let rest = path
      .replace(/^\/(webview\/)?v2/, "") // remove old base if any
      .replace(/\/(MTL|thailife)\//i, "/") // remove /MTL/ or /thailife/ from path
      .replace(/\/index\.html$/, "") // remove index.html at the end
      .replace(/\/+$/, ""); // remove trailing slash

    // Ensure it always ends with a slash if empty
    const finalPath = rest ? `${targetBase}${rest}` : `${targetBase}/`;

    // Preserve query + hash
    window.location.replace(`${finalPath}${search}${hash}`);
    return null;
  }

  return (
    <Router basename={basename}>
      <GtagInitializer enabled={true} />
      <MiddlewareWrapper />

      <Routes>
        <Route path="/" element={<AgreementPage />} />
        {/* <Route path="/" element={<Navigate to="/register" replace />} /> */}
        <Route path="/register" element={<Register />} />
        <Route path="/confirm" element={<Confirm />} />
        <Route path="/call" element={<Call />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/review" element={<Review />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/success" element={<Success />} />
        <Route
          path="/interpreter-select-language"
          element={<InterpreterSelectLanguage />}
        />

        {/* <Route path="/example" element={<Example />} /> */}

        {/* Strapi Draft */}
        {/* {config.enabledPages.includes("page1") && (
          <Route path="/page1" element={<Page1 />} />
        )}
        {config.enabledPages.includes("page2") && (
          <Route path="/page2" element={<Page2 />} />
        )}
        {config.enabledPages.includes("page3") && (
          <Route path="/page3" element={<Page3 />} />
        )} */}

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/connect-failed" element={<ConnectFailed />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-pin" element={<ForgotPin />} />

        {/* ✅ Fallback route for anything not matched */}
        {/* <Route path="*" element={<NotFound />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
